export const Plan = {
  Catalog: {
    free: {
      name: 'Free',
      priority: 0,
      monthlyFee: 0,
      teacherBasicPoints: 15000,
      studentBasicPoints: 9000,
      paidPointMultiplier: 2, // 콘텐츠 구매 포인트 차감에만 적용
    },
    plus: {
      name: 'Plus',
      priority: 1,
      monthlyFee: 38500,
      setupFee: 30000,
      teacherBasicPoints: 30000,
      studentBasicPoints: 12000,
      paidPointMultiplier: 1,
    },
    pro: {
      name: 'Pro',
      priority: 2,
      monthlyFee: 0,
      setupFee: 0,
      teacherBasicPoints: 50000,
      studentBasicPoints: 24000,
      paidPointMultiplier: 1,
    },
  },
  BillingPolicy: {
    minChargeAmount: 1000,
    chargeUnitAmount: 10,
  },
} as const;
